
import axios from 'axios';
import TextInput from 'components/inputs/TextInput/TextInput';
import { IImportFileNew, IParts } from 'interfaces/price';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useHttp from 'utils/hooks/useHttp';
import ReferenceDropdownOrder from './ReferenceDropdownOrder/ReferenceDropdownOrder';
import { Controller, useForm } from 'react-hook-form';
import CURRENCY from 'utils/constants/currency';
import { RootState } from 'store/store';
import { useSelector } from 'react-redux';
import { notify } from 'utils/marketplace';


type Props = {
  index: number;
  setSelectedItem: (item: IImportFileNew) => void;
  resetInputRef: boolean;
  setResetInputRef: (reset: boolean) => void;
  codFou?: string;
  item?;
  currentPage?: number;
  data?: IImportFileNew[];
  showReplace?: boolean;

};


const ReferenceSearchOrder: React.FC<Props> = (props) => {

  const { t } = useTranslation();
  const http = useHttp();
  const ref = useRef<HTMLInputElement>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [refData, setRefData] = useState<IImportFileNew[]>([]);
  const [inputValue, setInputValue] = useState<string>('');
  const cancelToken = axios.CancelToken.source();
  const [upEnter, setUpEnter] = useState<boolean>(false);
  const { setValue, control } = useForm();
  const [selectedItem, setSelectedItem] = useState<IParts>();
  const user = useSelector((state: RootState) => state.userData.user);


  function refInputChange(event) {

    const inputData = event.target.value.replace(/\s/g, '').length > 0 ? event.target.value : event.target.value.trim();

    if (inputData.length >= 3) {
      setInputValue(inputData);
    }

    if (inputData.length === 0) {
      setRefData([]);
      setIsOpen(false);
    }
  }

  const onKeyDown = (event) => {
    if (event.key === 'Enter') {
      const inputData = event.target.value.replace(/\s/g, '').length > 0 ? event.target.value : event.target.value.trim();

      setInputValue(inputData);
      setUpEnter(true);
    }
  };

  useEffect(() => {

    if (inputValue !== '') {
      setLoading(true);
      setIsOpen(true);
      const params: { q: string; codfou?: string } = { q: inputValue.trim() };

      if (props.codFou) {
        params.codfou = props.codFou;
      }


      http.searchByRefAll.getPriceOrder(params, cancelToken.token)
        .then((res) => {
          setRefData(res.data);
          setLoading(false);
        });
      setUpEnter(false);

      return () => {
        cancelToken.cancel();
      };
    }

  }, [inputValue, upEnter]);

  useEffect(() => {
    if (selectedItem) {
      const isRefExists = props.data?.some((item) =>
        item.parts.some((part) => part.reference == selectedItem.reference)
      );

      if (isRefExists) {
        notify(t('_item_already_exists'), 'warning');
      } else {
        setInputValue('');
        setIsOpen(false);
        setValue('reference_search_' + props.index, selectedItem.reference + ' ' + selectedItem.name + ' ' + Number(selectedItem.price).toFixed(2) + ' ' + CURRENCY[user!.currency]);

        const existingIndex = refData.findIndex((item) => {
          return item.code_fou === selectedItem.codfou;
        });

        const parent = refData[existingIndex];

        parent.parts = Array.from(new Set([selectedItem]));
        props.setSelectedItem(parent);
      }

    }
  }, [selectedItem]);

  useEffect(() => {
    if (props.resetInputRef) {
      setInputValue('');
      setValue('reference_search_' + props.index, '');
      props.setResetInputRef(false);
      setSelectedItem(undefined);

    }
  }, [props.resetInputRef]);


  useEffect(() => {
    if (props.currentPage && props.item && !props.showReplace) {

      if (props.item?.replaceRef && (props.item?.newRef !== undefined && props.item?.newRef !== null && props.item?.newRef.parts.length > 0)) {

        setValue('reference_search_' + props.index, props.item?.newRef.parts[0].reference + ' ' + props.item?.newRef.parts[0].name + ' ' + Number(props.item?.newRef.parts[0].price).toFixed(2) + ' ' + CURRENCY[user!.currency]);

      }
    }

  }, [props.currentPage]);

  useEffect(() => {

    if (props.showReplace) {
      setValue('reference_search_' + props.index, props.item?.reference + ' ' + props.item?.name + ' ' + Number(props.item?.price).toFixed(2) + ' ' + CURRENCY[user!.currency]);
    }

  }, [props.showReplace]);


  return (
    <div className="input-container">
      <Controller
        name={`reference_search_${props.index}`}
        control={control}
        render={({ field }) => (
          <TextInput
            placeholder={`${t('_search')}`}
            autoComplete="false"
            withIcon
            {...field}
            value={field.value ?? ''} // evită warningul de uncontrolled
            onChange={(e) => {
              field.onChange(e); // sync cu form
              refInputChange(e); // triggerul tău
            }}
            onKeyDown={onKeyDown}
            ref={ref}
            disabled={props.showReplace ? true : false}
          />
        )}
      />

      {isOpen && <ReferenceDropdownOrder setSelectedItem={setSelectedItem} refData={refData} setIsOpen={setIsOpen} loading={loading} />}
    </div>
  );
};

ReferenceSearchOrder.displayName = 'ReferenceSearchOrder';

export default ReferenceSearchOrder;
